import { clsx } from "clsx";
import { useTranslation } from "react-i18next";
import type { Level } from "../core/schema";
import { LEVELS } from "./settings";

/** "Simple · Normal · Expert" as one row of buttons (ADR 0013 look). `testId` prefixes each button's id. */
export function LevelChoice({
  value,
  onChange,
  label,
  testId,
  disabled,
}: {
  value: Level;
  onChange(level: Level): void;
  label: string;
  testId: string;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1.5 text-[12.5px]" role="group" aria-label={label}>
      {LEVELS.map((l, i) => (
        <span key={l} className="flex items-center gap-1.5">
          {i > 0 && (
            <span aria-hidden className="text-neutral-300 dark:text-neutral-600">
              ·
            </span>
          )}
          <button
            type="button"
            aria-pressed={value === l}
            disabled={disabled}
            onClick={() => onChange(l)}
            data-testid={`${testId}-${l}`}
            className={clsx(
              "rounded-sm px-1 py-0.5",
              value === l
                ? "font-semibold text-neutral-900 dark:text-neutral-100"
                : "text-neutral-500 hover:text-accent",
            )}
          >
            {t(`settings.level.${l}`)}
          </button>
        </span>
      ))}
    </div>
  );
}
